module.exports = __webpack_public_path__ + "static/media/dsc_2966.10e746bb.jpg";